import React from 'react';
import { Router } from '@reach/router';
import InvoicePaymentInfo from './invoice-payment-info';
import ROUTES from '../../../routes';


export const InvoicePaymentRouter = () => {
  return (
    <Router basepath="/">
      <InvoicePaymentInfo path={`${ROUTES.INVOICE_PAYMENT_PORTAL_INVOICE_PAYMENT}/*`} />
    </Router>
    
  );
};
export default InvoicePaymentRouter;

